import { connect } from 'react-redux';

import { getSecondCBILSInterestRate } from '../../../multiLoanDashboard/accountsSelector';
import * as selectors from '../../../../api/CBILSSelector';
import { getApplicantFirstName } from '../../../../api/lendingAPI/CustomerStateAPIHelper';

import { TitleSectionWrapper } from '../../../pageStructure/titleSectionWrapper/TitleSectionWrapper';
import { MainSectionWrapper } from '../../../pageStructure/mainSectionWrapper';
import { MoneyWithDecimals } from '../../../ui/moneyWithDecimals';
import { Rate } from '../../../ui/rate/Rate';
import { ActionButtonMakeRepayment } from '../../../multiLoanDashboard/dashboardComponents/actionButtonMakeRepayment/index';
import { FormattedName } from '../../../../iwIntlProvider/FormattedName';

import styles from '../../dashboard/outstandingLoanView/OutstandingLoanView.module.css';
import ApprovalStatusLines from '../ApprovalStatusLines';
import { RootState } from '@iwProvider/configureStore';

const mapStateToProps = (state: RootState) => ({
    approvalStatusPrincipalBalance:
        selectors.getSecondCBILSAccountOutstandingPrincipal(state),
    outstandingBalance: selectors.getSecondCBILSAccountOutstandingTotal(state),
    accountId: selectors.getSecondCBILSAccountId(state),
    firstName: getApplicantFirstName(state.api.customer_state.data),
    interestRate: getSecondCBILSInterestRate(state)
});

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

const OutstandingLoanView = ({
    approvalStatusPrincipalBalance,
    outstandingBalance,
    accountId,
    firstName,
    interestRate
}: PropsFromRedux) => (
    <div data-testid="outstanding-loan-view">
        <TitleSectionWrapper withBackground={true}>
            <div data-testid="headlineText" className={styles.headline}>
                Hi <FormattedName firstName={firstName} />, your 2nd CBILS loan
                outstanding balance is{' '}
                <MoneyWithDecimals
                    value={outstandingBalance}
                    decimalWithSeparatorClassName={styles.decimalsWithSeparator}
                />
            </div>

            <ApprovalStatusLines isSecondCBILSOffer={true} />

            <div data-testid="credit-outstanding">
                <span className={styles.amount}>
                    <MoneyWithDecimals
                        decimalWithSeparatorClassName={
                            styles.decimalsWithSeparator
                        }
                        value={approvalStatusPrincipalBalance}
                    />
                </span>

                <div className={styles.description}>Credit outstanding</div>
                <div>
                    <Rate value={interestRate!} decimalPlaces={2} /> Interest
                    rate per 30 days (interest covered by the government for the
                    first 12 months)
                </div>
            </div>
        </TitleSectionWrapper>
        <MainSectionWrapper>
            <ActionButtonMakeRepayment
                outstandingBalance={outstandingBalance!}
                accountId={accountId!}
            />
        </MainSectionWrapper>
    </div>
);

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(OutstandingLoanView);
